<template>
  <!-- OLD EVALUATION: Vertical -->
  <div>
    <!-- <p>{{ this.screeningID }}</p> -->
    <!--
      <screening-images id="screening-images" :img-arr="imgArr" />
    -->

    <md-card id="evalcontainer" style="margin-top: 50px">
      <md-card-header style="background-color: #0d7ea4">
        <!--  #1565c0;-->
        <div class="panel-heading panel-heading-divider" style="color: white">
          <span style="font-size: 1rem; font-weight: 400">Diagnose Screening Results</span>
          <br />
          <span class="panel-subtitle">Generate Screening Report</span>
        </div>
      </md-card-header>

      <md-card-content align="Left">
        <screening-images id="screening-images" />

        <patient-screening-info />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <notes-info />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <vision-info />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <!-- PRESCRIPTION RX-->
        <prescription-info :m-screening="screeningID" :m-patient="mbrUsername" :m-rx="rxValues"
          prescription-type="glasses" v-on:changedRx="updateRx($event)" :showNoRefraction="true" />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <!-- PRESCRIPTION CONTACT LENS-->
        <prescription-info :m-screening="screeningID" :m-patient="mbrUsername" :m-rx="contactLensValues"
          prescription-type="contact" v-on:changedRx="updateContactLens($event)" :showNoRefraction="true" />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <external-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <cornea-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <pachymetry-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <opacity-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <fundus-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <macula-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <nerve-photo />
        <hr style="width: 95%; border-bottom: 2px solid #4269a7; margin-right: 3%" />

        <eval-diagnose-recommend />
        <ICD10 :is-loading="isICD10Loading" />
        <!--<eval-comments/>-->

        <eval-referral :mZip="mbrZip" :mState="mbrState" />

        <!--<hr style="width: 95%; border-bottom: 5px solid #4269a7; margin-right: 3%; ">-->
      </md-card-content>

      <md-card-actions md-alignment="space-between">
        <div class="md-label" />
        <md-button class="md-primary" @click="togglePreview('pdfreport')">Preview Report</md-button>
        <md-button class="md-primary" @click="toggleRxPreview('pdfreport')">PREVIEW GLASSES RX</md-button>
        <md-button class="md-primary" @click="toggleRxLensPreview('pdfreport')">PREVIEW CONTACT RX</md-button>
        <div class="md-label" />
      </md-card-actions>

      <template>
        <go-top />
      </template>
    </md-card>

    <!-- MODAL REPORT PREVIEW     md-dynamic-height -->
    <modal v-if="rptPreview" style="overflow: auto; height: 83vh" m-container="modal-container-report">
      <template slot="body">
        <div class="md-layout">
          <!--   @click="rptPreview = false" -->
          <div class="md-layout-item">
            <reportpreview id="pdfreport" :rxValues="rxValues" :rxContactValues="contactLensValues"
              @onCloseRPT="handleRptClose" />
          </div>
        </div>
      </template>
    </modal>

    <!-- MODAL Rx-REPORT PREVIEW     md-dynamic-height -->
    <modal v-if="rxRptPreview" style="overflow: auto; height: 83vh" m-container="modal-container-report">
      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <rxreportpreview id="pdfreport" :rxValues="rxValues" @onCloseRX="handleRxClose"
              @onReportGenerated="handleRxClose" :title="`GLASSES`" />
          </div>
        </div>
      </template>
    </modal>

    <!-- MODAL Rx-Lens-REPORT PREVIEW     md-dynamic-height -->
    <modal v-if="rxLensRptPreview" style="overflow: auto; height: 83vh" m-container="modal-container-report">
      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <rxreportpreview id="pdfreport" :rxValues="contactLensValues" @onCloseRX="handleRxLensClose"
              @onReportGenerated="handleRxLensClose" :title="`CONTACT`" />
          </div>
        </div>
      </template>
    </modal>

    <hr />
    <!--
    <hr style="width: 95%; border-bottom: 5px solid #4269a7; margin-right: 3%; ">
    -->
    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import ScreeningImages from "@/components/GlobeChek/screening/screening-images"
import InfoPatientScreening from "@/components/GlobeChek/screening/info-screening-patient"
import InfoVision from "@/components/GlobeChek/screening/info-vision"
import InfoRxPrescription from "@/components/GlobeChek/screening/info-rx-prescription"
import InfoScreeningNotes from "@/components/GlobeChek/screening/info-screening-notes.vue"

import PhotoExternal from "@/components/GlobeChek/screening/photo-external"
import PhotoCornea from "@/components/GlobeChek/screening/photo-cornea"
import PhotoPachymetry from "@/components/GlobeChek/screening/photo-pachymetry"
import PhotoOpacity from "@/components/GlobeChek/screening/photo-opacity"
import PhotoFundus from "@/components/GlobeChek/screening/photo-fundus"
import PhotoMacula from "@/components/GlobeChek/screening/photo-macula"
import PhotoNerve from "@/components/GlobeChek/screening/photo-nerve"

import EvalDiagnoseRecommend from "@/components/GlobeChek/screening/eval-diagnose-recommend"
import EvalReferral from "@/components/GlobeChek/screening/eval-referral"
//import EvalCommnets from "@/components/GlobeChek/screening/eval-comments";

import ReportPreview from "@/components/GlobeChek/screening/dispense-report-preview"
import RxReportPreview from "@/components/GlobeChek/screening/eval-rxreport-preview"

import { Modal } from "@/components"
import GoTop from "@inotom/vue-go-top"
import { mapGetters, mapActions } from "vuex"
import loader from "@/components/GlobeChek/loader.vue"
import { bus } from "@/main"
import { ThisMonthInstance } from "twilio/lib/rest/api/v2010/account/usage/record/thisMonth"
import icd from "@/components/GlobeChek/screening/icd"
import screeningsService from "@/services/screenings-service"
import Swal from "sweetalert2"

export default {
  name: "Evaluation",
  components: {
    // Info
    "screening-images": ScreeningImages,
    "patient-screening-info": InfoPatientScreening,
    //'screening-assets-info': InfoScreeningAssets,
    "vision-info": InfoVision,
    "notes-info": InfoScreeningNotes,
    "prescription-info": InfoRxPrescription,
    // Photo
    "external-photo": PhotoExternal,
    "cornea-photo": PhotoCornea,
    "pachymetry-photo": PhotoPachymetry,
    "opacity-photo": PhotoOpacity,
    "fundus-photo": PhotoFundus,
    "macula-photo": PhotoMacula,
    "nerve-photo": PhotoNerve,
    // Summary
    "eval-diagnose-recommend": EvalDiagnoseRecommend,
    "eval-referral": EvalReferral,
    ICD10: icd,
    //"eval-comments": EvalCommnets,
    reportpreview: ReportPreview,
    rxreportpreview: RxReportPreview,
    Modal,
    GoTop,
    loader
  },
  props: ["bus"],
  data() {
    return {
      isLoading: false,
      axiosInterceptor: null,
      isICD10Loading: false,
      API_SERVICE: process.env.VUE_APP_URL,
      rptPreview: false,
      showPreview: false,
      rxRptPreview: false,
      rxLensRptPreview: false,
      showRxLensPreview: false,
      showRxPreview: false,

      //screeningID: null,
      //mbrUsername: null,
      //mbrZip: null,
      //mbrState: null,
      imgPrefix: process.env.VUE_APP_SCREENING_PACKAGES,

      rxValues: {
        odSPH: null,
        odCYL: null,
        odAXS: null,
        odPOW: null,
        odDIS: null,
        osSPH: null,
        osCYL: null,
        osAXS: null,
        osPOW: null,
        osDIS: null,
        ouCOM: null
      },

      contactLensValues: {
        odSPH: null,
        odCYL: null,
        odAXS: null,
        odPOW: null,
        odDIS: null,
        odBC: null,
        odDIA: null,
        odCOL: null,
        odBRA: null,
        odMAN: null,
        odQT: null,
        osSPH: null,
        osCYL: null,
        osAXS: null,
        osPOW: null,
        osDIS: null,
        osBC: null,
        osDIA: null,
        osCOL: null,
        osBRA: null,
        osMAN: null,
        osQT: null,
        ouCOM: null
      }
    }
  },
  watch: {
    'screening.orgID'(newVal) {
      if (newVal) {
        this.listDxCards()
      }
    }
  },
  computed: {
    ...mapGetters([
      "screening",
      "screeningID",
      "eval",
      "getSelectedFindings",
      "StateFindings",
      "evalResults",
      "getSavedDiagnoses",
      "referrals"
    ]),
    mbrZip: function () {
      return this.screening.mbrZip
    },
    mbrState: function () {
      return this.screening.mbrState
    },
    mbrUsername: function () {
      return this.eval.patientInfo.email
    }
  },
  created: function () {
    //console.log("***EVAL-CREATED: " + sessionStorage.getItem("screeningID") + " | " + sessionStorage.getItem("storageID"))
    //MOVED LoadImages to itemSelected event in Screenings vue
    //this.$store.dispatch("loadImages", sessionStorage.getItem("storageID"));

    this.$store.dispatch("loadScreening", { screeningID: sessionStorage.getItem("screeningID"), detailed: true }) // (payload) => this.$route.params.id
    this.$store.dispatch("clearReferrals", null) // CLEAR REFERRALS
    sessionStorage.setItem("patientUserName", this.eval.patientInfo.patientUserName)
    this.setReadingDoctor()
  },
  mounted: function () {
    bus.$on("showPreview", (data) => {
      this.togglePreview(data)
    })
    bus.$on("showRxPreview", (data) => {
      this.toggleRxPreview(data)
    })
    bus.$on("showRxLensPreview", (data) => {
      this.toggleRxLensPreview(data)
    })
    bus.$on("executeSave", (data, showConfirmationModal) => {
      this.PlaceScreeningOnHold(data, showConfirmationModal)
    })
    this.enableInterceptor()
    // this.PlaceScreeningOnHold();

    this.listAllImages()
  },
  unmounted: function () {
    this.clearALLImages()
  },
  updated: function () { },
  beforeDestroy: function () {
    this.$store.dispatch("clearEval", null)
    sessionStorage.setItem("rxDispensed", null)
    sessionStorage.setItem("contactRxDispensed", null)
  },
  destroyed: function () {
    bus.$off("showPreview")
    bus.$off("showRxPreview")
    bus.$off("executeSave")
  },

  methods: {
    ...mapActions(["imagePickerList", "fetchDxCards", "updateFindings"]),
    setReadingDoctor() {
      let fn = sessionStorage.getItem("firstname")
      let ln = sessionStorage.getItem("lastname")
      let readingDoctor = fn + " " + ln + " " + "MD"
      sessionStorage.setItem("ReadingDoctor", readingDoctor)
    },

    handleRxClose() {
      this.rxRptPreview = false
      this.rxLensRptPreview = false
    },

    handleRxLensClose() {
      this.rxLensRptPreview = false
    },

    handleRptClose() {
      this.rptPreview = false
    },

    updateRx(updatedRx) {
      this.rxValues = updatedRx
    },

    updateLensRx(updatedLensRx) {
      this.rxValues = updatedLensRx
    },

    updateContactLens(updatedContactLens) {
      this.contactLensValues = updatedContactLens
    },

    togglePreview(refName) {
      this.showPreview = !this.showPreview
      this.rptPreview = !this.rptPreview
      const currentStatus = this.$store.getters["screeningStatus"].toLowerCase()
      var element = this.$refs[refName]
      bus.$emit("saveRx")
      bus.$emit("executeSave", currentStatus, false)
      bus.$emit("saveFindingsInStorage")
    },

    toggleRxPreview(refName) {
      this.showRxPreview = !this.showRxPreview
      this.rxRptPreview = !this.rxRptPreview
      var element = this.$refs[refName]
      bus.$emit("saveRx")
    },

    toggleRxLensPreview(refName) {
      this.rxLensRptPreview = !this.rxLensRptPreview
      bus.$emit("saveRx")
    },

    computeAR_Sphere(paramAR) {
      if (paramAR) {
        var arSph = paramAR.slice(0, paramAR.indexOf(" "))
        return arSph
      }
    },

    computeAR_Cylinder(paramAR) {
      if (paramAR) {
        var arCyl = paramAR.slice(paramAR.indexOf(" "), paramAR.indexOf("x"))
        return arCyl
      }
    },

    computeAR_Axis(paramAR) {
      if (paramAR) {
        var arAxi = paramAR.slice(paramAR.indexOf("x") + 1)
        return arAxi
      }
    },

    previewReport: function () {
      this.rptPreview = true
    },

    previewRxReport: function () {
      this.rxRptPreviewPreview = true
    },

    generateReport: function () {
      if (document.querySelector("#pdf")) {
        const top = `<!DOCTYPE html><html lang="en"><head><link href="./rptAssets/css/reportDesign-view.css" rel="stylesheet" type="text/css"  /></head><body>`
        const bottom = `</body></html>`
        const reportHTML = top + document.querySelector("#pdf").innerHTML + bottom

        //Call PDFFUnc with MASTER KEY
        var pdfFunc =
          "https://gcfunction.azurewebsites.net/api/CreatePDFfromHTML?code=iJgERugbMtZ31KAsy7Nl6mSSuhn6PrvNcaa1oM6ixtzZkDlNKB9keg==&pkg="

        var uri = pdfFunc + this.screeningID + ".html"
        var rptFile = new File([reportHTML], "../rptFile.html", {
          type: "text/html"
        })

        //-START DOWNLOAD RTPFILE HTML
        const mdata = rptFile
        const blob = new Blob([mdata], { type: "text/html" })
        const e = document.createEvent("MouseEvents"),
          a = document.createElement("a")
        a.download = "report.html"
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl = ["text/html", a.download, a.href].join(":")
        e.initEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
        //-END DOWNLOAD RTPFILE HTML

        const config = { headers: { "Content-Type": "application/json" } }
        const url = this.API_SERVICE + "/report-html"
        const data = {
          Id: sessionStorage.getItem("storageID"), // this.screeningID,
          reportHtml: reportHTML
        }

        window.axios
          .post(url, data, config)
          .then(function (response) {
            window.open(uri, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes")
          })
          .catch(function (error) {
            alert("PDF Creation Error: " + error)
          })
      }
    },

    async PlaceScreeningOnHold(status = "hold", showConfirmationModal) {
      if (this.isLoading) return
      this.isLoading = true
      const vm = this
      const newStatus = status
      const screening = sessionStorage.getItem("screeningID") //this.screeningID;
      const reader = sessionStorage.getItem("userID")

      if (reader) {
        const config = { headers: { "Content-Type": "application/json" } }
        const url = this.API_SERVICE + "/screening/" + screening + "/" + newStatus + "/" + reader //[screening-status]
        const data = null

        await window.axios
          .put(url, data, config)
          .then(function (response) {
            vm.status = response.data
            vm.$forceUpdate()
          })
          .catch(function (error) {
            vm.status = "An error occurred: " + error
            console.log(vm.status)
          })
          .finally(() => (this.isLoading = false))
      }

      this.PersistFindings(status, showConfirmationModal)
    },

    async PersistFindings(status, showConfirmationModal = true) {
      if (this.isLoading) return
      this.isLoading = true
      const selectedFindings = this.getSelectedFindings
      const evalResults = this.evalResults
      const doctorReferrals = this.referrals
      const savedDiagnoses = this.getSavedDiagnoses
      const payload = screeningsService.defineUpdatePayload(
        selectedFindings,
        evalResults,
        savedDiagnoses,
        doctorReferrals
      )

      try {
        await this.updateFindings({ payload, status })
        let text = ""
        switch (status) {
          case "Hold":
            text = "...and placed in your on-hold queue."
            break
          case "New":
            text = "and placed in your available screening queue."
            break
          case "Save":
          default:
            break
        }

        if (showConfirmationModal) {
          Swal.fire({
            title: `Evaluation Saved!`,
            text: text,
            buttonsStyling: false,
            confirmButtonClass: "md-button md-success",
            type: "success"
          }).then(() => {
            switch (status) {
              case "Hold":
                this.$router.push({ path: "/portal/reader/onhold" })
                break
              case "New":
                this.$router.push({ path: "/portal/reader/screenings" })
                break
              case "Save":
              default:
                break
            }
          })
        }
      } catch (error) {
        console.error("Error persisting findings: ", error)
        Swal.fire({
          title: `Error Saving Evaluation`,
          text: "An error occurred while saving the evaluation.",
          buttonsStyling: false,
          confirmButtonClass: "md-button md-danger",
          type: "error"
        })
      } finally {
        this.isLoading = false
      }
    },

    listAllImages() {
      let payload = {
        pkgID: sessionStorage.getItem("storageID"),
        showPicker: false
      }
      this.$store.dispatch("imagePickerList", payload)
    },
    async listDxCards() {
      await this.fetchDxCards({ orgID: this.screening.orgID, plain: false })
    },
    enableInterceptor() {
      // filter urls from Dx Search to only use local loading
      const dxSearchUrls = ["dx-cards/dxSearch", "ai/claude/clinical", "/ai/claude/dxrec"]
      this.axiosInterceptor = window.axios.interceptors.request.use(
        (config) => {
          if (config && config.url) {
            if (config.url.includes("/ai/claude/icd10/suggestion")) {
              this.isICD10Loading = true
            } else if (!dxSearchUrls.some((urlPart) => config.url.includes(urlPart))) {
              this.isLoading = true
            }
          }
          return config
        },
        (error) => {
          this.isICD10Loading = false
          this.isLoading = false
          return Promise.reject(error)
        }
      )

      window.axios.interceptors.response.use(
        (response) => {
          this.isLoading = false
          this.isICD10Loading = false
          return response
        },
        (error) => {
          this.isLoading = false
          this.isICD10Loading = false
          return Promise.reject(error)
        }
      )
    },

    disableInterceptor() {
      window.axios.interceptors.request.eject(this.axiosInterceptor)
    }
  }
}
</script>

<style lang="scss" scoped>
#evalcontainer {
  max-width: 1500px; //1250px;
  //width: 320px;
  margin-top: 0px;
  //display: inline-block;
  //vertical-align: top;
  background-color: rgba(18, 180, 235, 0.1);
  height: 83vh;
  overflow: auto;
}

#screening-images_original {
  //top: 0;
  //position: fixed;
  max-width: 1500px; //1250px;
  z-index: 100;
  width: 95%;
  margin: 0px;
  padding: 0px;
  display: inline-block;
  vertical-align: top;
}

#screening-images {
  //top: 0;
  //position: fixed;
  max-width: 500px; //1250px;
  z-index: 100;
  width: 95%;
  margin: 0px;
  padding: 0px;
  //display: inline-block;
  //@debugvertical-align: top;
}
</style>
